import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { Component, ElementRef, ChangeDetectionStrategy, ViewEncapsulation, OnInit } from '@angular/core';
import { FormQuestionType } from '@fi-shared/fi-form-shared/fi-form-enums';
import { FiFormHelperService } from '@fi-shared/fi-form-shared/fi-form-helper.service';
import { FiFormQuestionBase } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-question-base';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { IMediaBankFileReference } from '@fi-shared/media-bank';

@Component({
    selector: 'fi-form-additional-text-element',
    templateUrl: './fi-form-additional-text-element.component.html',
    styleUrls: [
        '../fi-form-text-question/fi-form-text-question.component.scss',
        './fi-form-additional-text-element.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [{ provide: FiComponentsContainer, useExisting: FiFormAdditionalTextElementComponent }],
    host: { class: 'fi-form-additional-text-element' },
    standalone: false,
})
export class FiFormAdditionalTextElementComponent extends FiFormQuestionBase implements OnInit {
    protected mediaBankFileReferencesMapping: {
        [contentLanguageId: number]: IMediaBankFileReference[];
    };

    constructor(
        fiBrowserEventsService: FiBrowserEventsService,
        elementRef: ElementRef,
        formHelperService: FiFormHelperService,
    ) {
        super(fiBrowserEventsService, elementRef, formHelperService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setMediaBankFileReferencesMapping();
    }

    private setMediaBankFileReferencesMapping() {
        this.mediaBankFileReferencesMapping = {};
        this.question.Names.forEach((name, idx) => {
            const contentLanguageId = name.ContentLanguageId;
            this.mediaBankFileReferencesMapping[contentLanguageId] = this.question.MediaBankFileReferences.filter(
                (mbRef) => mbRef.ContentLanguageId === contentLanguageId || (!mbRef.ContentLanguageId && idx === 0),
            );
        });
    }

    onAttachmentsChanged($event: IMediaBankFileReference[]) {
        let newMediaBankFileReferences: IMediaBankFileReference[] = [];
        this.question.Names.forEach((name) => {
            const contentLanguageId = name.ContentLanguageId;
            newMediaBankFileReferences = newMediaBankFileReferences.concat(
                this.mediaBankFileReferencesMapping[contentLanguageId],
            );
        });
        this.question.MediaBankFileReferences = newMediaBankFileReferences;
    }

    isHeadingElement(): boolean {
        return this.question.Type === FormQuestionType.Heading;
    }

    isTextMessageElement(): boolean {
        return this.question.Type === FormQuestionType.TextMessage;
    }
}
